// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-2GMa4";
var _4 = "text-1_ofL";
var _5 = "wrapper-1zxrR";
var _6 = "content-a1kb4";
var _7 = "footer-26Hup";
var _8 = "slider_buttons-26THx";
var _9 = "slider_button-2-Nl0";
var _a = "slider_button_prev-17y9x";
var _b = "slider-1QtBn";
var _c = "small-2OOs4";
var _d = "total-GwFML";
var _e = "card-3GvXU";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "text", _5 as "wrapper", _6 as "content", _7 as "footer", _8 as "slider_buttons", _9 as "slider_button", _a as "slider_button_prev", _b as "slider", _c as "small", _d as "total", _e as "card" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "text": _4, "wrapper": _5, "content": _6, "footer": _7, "slider_buttons": _8, "slider_button": _9, "slider_button_prev": _a, "slider": _b, "small": _c, "total": _d, "card": _e }
